<div class=" banner_header">
    <div class="col-md-12">
        <h2>Instructions</h2>
    </div>
</div>

<div class="container">
    <div class="row download_section">
        <div class="col-md-12">
            <h2>Guidelines For Examination Center</h2>
        </div>
    </div>

        <div class="row">
            <div class="col-md-12 step_cls">
               <span class="steps"> 1 </span>  <p> System working condition should be verified</p>               
               <span class="steps"> 2 </span>  <p> Internet connectivity to each Systems to be verified.</p>
               <span class="steps"> 3 </span>  <p> Poor Internet Connectivity to be rectified.</p>               
               <span class="steps"> 4 </span>  <p> Safe Exam Browser to be Installed in all the Systems.</p>               
               <span class="steps"> 5 </span>  <p> Configuration File and password for Safe Exam Browser which was given by NIMI to be changed and executed in every system before starting the exam daily.</p>               
               <span class="steps"> 6 </span>  <p> Exam should be taken only in Safe Exam Browser.</p>               
               <span class="steps"> 7 </span>  <p> Proper Seating arrangements should be made with Social Distance.</p>               
               <span class="steps"> 8 </span>  <p> Power backup - UPS / Generator should be available to manage Power Failure for the Systems.</p>               
               <span class="steps"> 9 </span>  <p> Web Camera with Zoom Connectivity should be available in Examination Hall.</p>               
               <span class="steps"> 10 </span>  <p> Systems to be Configured with required Software’s.</p>               
               <span class="steps"> 11 </span>  <p> One / Two Backup Systems should be available.</p>               
               <span class="steps"> 12 </span>  <p> One Technical Person should be available in Examination Centre.</p>        
               
       

            </div>
          
         </div>


         <div class="row download_section ">
            <div class="col-md-12">
                <h2>General guidelines to candidates for AITT - CBT</h2>
            </div>
        </div>
    
            <div class="row dwn_btm">
                <div class="col-md-12 step_cls">
                    <span class="steps"> 1 </span>  <p> Invigilator should verify for Student Authentication.</p>               
                    <span class="steps"> 2 </span>  <p> Discussion between the Students should not be allowed.</p>
                    <span class="steps"> 3 </span>  <p> Candidate System Browser and Tab Switchover to be Monitored</p>               
                    <span class="steps"> 4 </span>  <p> No Mobile, Electronic Devices and Other Communicating Device should be allowed in the Examination Hall.</p>               
                    <span class="steps"> 5 </span>  <p> Attendance should be captured in Mobile App and Manual Attendance also to be Captured with Student Signature.
                        User Manual for AITT Attendance Mobile Application - <a class="click_here" href="https://www.nimionlinetesting.in/aitt_exam/pdf/AITT-NIMI-MOBILE-USERMANUAL.pdf" target="_blank"> Click Here </a></p>               
                    <span class="steps"> 6 </span>  <p> Unauthorized Person Entry in Examination Hall to be restricted.</p>               
                    <span class="steps"> 7 </span>  <p> Invigilator should not Help Students in Answering Questions.</p>               
                             
                </div>
             </div>




             
    </div>




<style>
    .banner_header{
        background: #2955a9;
    padding: 10px 0px;
    text-align: left;
    color: #fff;
    margin: 0px;
    }
    .banner_header h2{
        font-size: 21px;
    }
    .download_section{        
        padding: 40px 0px;
        text-align: center;
    }
    .dwn_btm{
        padding-bottom: 60px;
    }
    .steps{
        left: 0px;
    height: 30px;
    width: 30px;
    background-color: #29ab55;
    border-radius: 50%;
    display: inline-block;
    font-size: 18px;
    text-align: center;
    color: #fff;
    position: absolute;
    }
    .step_cls{
        padding: 0px 40px 30px;
    }
    .click_here{
        background: #2955a9;
    padding: 5px 15px;
    color: #fff;
    font-size: 10px;
    font-weight: 500;
    border-radius: 10px;
    width: fit-content;
    cursor: pointer;
    }
    .click_here:hover{
        background-color: #000;
        text-decoration: none;
    }

    @media only screen and (max-width: 767px)  {      
       h2{
      font-size: 24px;
      text-align: center;
    }
    .steps{
        left: 20px
    }
    .click_here{
        display: block;
    }
    .step_cls {
        padding: 0px 70px 30px;
    }

    }
   
</style>